(function($) {
    $.fn.shareSns = function() {
        return this.each(function() {
            new shareSns(this);
        });
    };

    var shareSns = function(elem) {
        var $twitter = $(elem).find('[data-js-share-twitter]'),
            $hatebu = $(elem).find('[data-js-share-hatebu]'),
            $facebook = $(elem).find('[data-js-share-facebook]'),
            $line = $(elem).find('[data-js-share-line]'),
            url = encodeURIComponent(window.location.href),
            title = encodeURIComponent(document.title);

        // 各SNSのシェアURLを正しくセット
        $twitter.attr('href', 'https://twitter.com/share?url=' + url + '&text=' + title);
        $hatebu.attr('href', 'https://b.hatena.ne.jp/entry/' + url);
        $facebook.attr('href', 'https://www.facebook.com/share.php?u=' + url);
        $line.attr('href', 'https://social-plugins.line.me/lineit/share?url=' + url);
    };

})(jQuery);
